var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeftSm = function SvgChevronLeftSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-left-sm_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.214 24.849 21.064 33l8.15 8.151 8.15 8.15 1.426-1.424 1.425-1.425-6.726-6.726L26.763 33l6.726-6.726 6.726-6.726-1.425-1.425-1.425-1.425z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronLeftSm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI5LjIxNCAyNC44NDlMMjEuMDYzMSAzM0wyOS4yMTQgNDEuMTUxTDM3LjM2NDkgNDkuMzAxOUwzOC43ODk5IDQ3Ljg3NjlMNDAuMjE0OSA0Ni40NTE5TDMzLjQ4OSAzOS43MjZMMjYuNzYzMSAzM0wzMy40ODkgMjYuMjc0TDQwLjIxNDkgMTkuNTQ4TDM4Ljc4OTkgMTguMTIzTDM3LjM2NDkgMTYuNjk4TDI5LjIxNCAyNC44NDlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";